import { ActionFunctionArgs, redirect } from 'react-router';
import { authClient } from '../../../lib/auth-client';

export async function loginAction({ request }: ActionFunctionArgs) {
  const form = await request.formData();
  const email = String(form.get("email") || "");
  const password = String(form.get("password") || "");
  const redirectTo = String(form.get("redirectTo") || "");
  const url = new URL(request.url);
  const from = url.searchParams.get("from") || redirectTo;

  try {
    const { data, error } = await authClient.signIn.email({
      email,
      password,
    });

    if (error) {
      return { error: error.message || "Invalid credentials" };
    }

    if (data) {
      // Simple redirect logic - let the dashboard loader handle onboarding checks
      const target = safeRedirect(from, "/dashboard");
      throw redirect(target);
    }

    return { error: "Login failed" };
  } catch (e) {
    if (e instanceof Response) throw e; // rethrow redirects/errors
    console.error("login.action error", e);
    return { error: "Unexpected error" };
  }
}

function safeRedirect(to: unknown, fallback = "/dashboard") {
  if (typeof to !== "string") return fallback;
  if (!to.startsWith("/") || to.startsWith("//")) return fallback;
  return to;
}// Build timestamp: Wed Aug 13 13:20:00 EDT 2025
